//GPT Conversations
export const SET_GPT_CONVERSATION_DETAILS = "SET_GPT_CONVERSATION_DETAILS"
export const SET_GPT_PROFILES = "SET_GPT_PROFILES"
export const SET_GPT_CONVERSATION_SUMMARY = "SET_GPT_CONVERSATION_SUMMARY"
export const SET_CONVERSATION_HISTORY = "SET_CONVERSATION_HISTORY"

//Call
export const SET_CALLS = "SET_CALLS"
export const SET_CALL_DETAIL = "SET_CALL_DETAIL"

//Download
export const SET_PRESIGNED_URL = "SET_PRESIGNED_URL"

//get generated masked version
export const SET_GENERATED_MASKED_TRANSCRIPTION = "SET_GENERATED_MASKED_TRANSCRIPTION";



//Save generated masked version of Conversation
export const SET_MASKED_CONVERSATION = "SET_MASKED_CONVERSATION";

// Project
export const SET_PROJECT_ENTRIES = "SET_PROJECT_ENTRIES";
export const SET_ACTIVE_PROJECT = "SET_ACTIVE_PROJECT";
export const SET_INITIALIZED = "SET_INITIALIZED";
export const SET_ENTRY_ACCESS = "SET_ENTRY_ACCESS";




//Account
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAILURE = "LOGIN_FAILURE"
export const SET_LOGIN_ERROR = "SET_LOGIN_ERROR"
export const LOGOUT_USER = "LOGOUT_USER"
export const SWITCH_SUCCESS = "SWITCH_SUCCESS"
export const SET_ORGANIZATION = "SET_ORGANIZATION"
export const SET_ACCESS_TAGS = "SET_ACCESS_TAGS"
export const SET_PROJECT_ROLE = "SET_PROJECT_ROLE";
export const SET_RESET_PASSWORD_USER_DETAILS = "SET_RESET_PASSWORD_USER_DETAILS"
//Alert
export const CREATE_ALERT = "CREATE_ALERT"
